import { apiConstants } from '../../apiConstant'
import { formDataCommonFunctionPut, formDataCommonFunctionPutWithoutAuth, formDataCommonFunctionUnAuth, serviceCallAuth } from '../../serviceCall'

export const resendCode = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunctionPutWithoutAuth(data, apiConstants.AUTH.RESEND_ACTIVATION_CODE)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
} 
